import { useEffect } from 'react'
import type { Editor } from '@tiptap/react'
import {
  useFieldMap,
  selectTensionParagraphIndices,
  selectDominatedParagraphIndices,
} from './useFieldMap'
import { setFieldSalience } from '../components/FieldSalienceDecoration'

interface Options {
  editor: Editor | null
  postId: number | null
  enabled?: boolean
}

/**
 * Wire `useFieldMap` data into the `FieldSalienceDecoration` plugin.
 * Each time the field_map response updates (poll tick / refetch), we
 * push the new tension + dominated index sets to the editor view via
 * a meta-tagged transaction. The plugin recomputes decorations from
 * those sets — no CRDT mutation.
 */
export function useApplyFieldSalience({
  editor,
  postId,
  enabled = true,
}: Options) {
  const { data } = useFieldMap({ postId, enabled })

  useEffect(() => {
    if (!editor || !enabled) return
    const view = editor.view
    if (!view) return
    const tensions = selectTensionParagraphIndices(data)
    const dominated = selectDominatedParagraphIndices(data)
    setFieldSalience(view, tensions, dominated)
  }, [editor, data, enabled])
}
